import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  isLoggedIn: false,
};

export const raceAndExerciseReducer = createReducer(initialState, {
  [types.EXERCISE_DROPDOWN](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.SUBJECT_DROPDOWN](state, action) {
    return {
      ...state,
      subjectData: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.WORKBOOK_DETAILS](state, action) {
    return {
      ...state,
      workbookData: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
